import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
const kitBenefits = ['Manual completo de Tarot', 'Interpretación de las 78 cartas', 'Significados derecho e invertido', 'Guiones para tus lecturas', 'Fichas de consulta', 'Tiradas terapéuticas', 'Ejercicios prácticos', 'Registro y seguimiento'];
const titleReveal = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    amount: 0.15
  },
  transition: {
    duration: 0.55,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
const copyReveal = {
  initial: {
    opacity: 0,
    y: 15
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    amount: 0.15
  },
  transition: {
    duration: 0.45,
    delay: 0.1,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
export function DiferencialHibrido() {
  const scrollToPurchase = () => document.getElementById('purchase')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="border-y border-[#eadfc9] bg-[#fffdf8] py-10 sm:py-12 lg:py-14" data-id="element-108" data-mp="11m79et2eze7q">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-8" data-id="element-109" data-mp="21j2o3membibf">
        <div className="mx-auto max-w-3xl text-center" data-id="element-110" data-mp="1wjzj21yn1c3g">
          <motion.p {...titleReveal} className="text-[10px] font-black uppercase tracking-[0.24em] text-[#b88631] sm:text-[11px]" data-id="element-111" data-mp="1wmlzys7f53yc">
            La solución que estabas buscando
          </motion.p>
          <motion.h2 {...titleReveal} transition={{
          ...titleReveal.transition,
          delay: 0.04
        }} className="mt-4 font-magical text-4xl font-bold leading-[0.94] tracking-tight text-purple-950 sm:text-5xl md:text-6xl" data-id="element-112" data-mp="1mslnu6dpyyg4">
            Todo lo que necesitás para <span className="text-purple-800" data-id="element-113" data-mp="18uew77zd5uow">interpretar con más seguridad.</span>
          </motion.h2>
          <motion.p {...copyReveal} className="mx-auto mt-5 max-w-2xl text-sm font-medium leading-relaxed text-purple-950/70 sm:text-base" data-id="element-114" data-mp="13wdi71gsolka">
            Conocé el Kit de Tarot Terapéutico: un sistema completo de guías, fichas y herramientas prácticas para acompañarte en cada lectura.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.65,
        ease: [0.22, 1, 0.36, 1]
      }} className="mt-6 w-full sm:mt-8" data-id="element-115" data-mp="wjnvliemz9s2">
          <div className="solution-kit-float" data-id="element-116" data-mp="rkt8i49myz25">
            <img src="https://cdn.magicpatterns.com/uploads/4zUybdVwZRSXBYpXaavnap/Kit_de_Tarot_Terapeutico_Profesional.webp" alt="Kit completo de Tarot Terapéutico Profesional con manual, fichas, ejercicios y herramientas" className="h-auto w-full object-contain" data-id="element-117" data-mp="rji4q4g6xrb1" />
          </div>
        </motion.div>

        <motion.div {...copyReveal} className="mx-auto mt-5 max-w-3xl sm:mt-6" data-id="element-118" data-mp="15fdf1lwixu2t">
          <p className="text-center text-[10px] font-black uppercase tracking-[0.22em] text-[#b88631] sm:text-[11px]" data-id="element-119" data-mp="1aa988pdhynhi">
            Todo lo que incluye tu kit
          </p>
          <ul className="mt-4 grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] grid-rows-4 gap-x-2.5 gap-y-3 text-left" aria-label="El kit incluye" data-id="element-120" data-mp="3v3e0m0s87a9i">
            {kitBenefits.map(benefit => <li key={benefit} className="flex min-h-[36px] items-center gap-2 text-[12px] font-semibold leading-snug text-purple-950 sm:text-[13px]" data-id="element-121" data-mp="286enfj27ttbr">
                <Check size={14} strokeWidth={2.3} className="shrink-0 text-[#b88631]" aria-hidden="true" data-id="element-122" data-mp="2m31uienvtzve" />
                <span data-id="element-123" data-mp="1ue83rmzut47k">{benefit}</span>
              </li>)}
          </ul>
          <p className="mx-auto mt-5 max-w-2xl text-center text-sm leading-relaxed text-purple-950/70" data-id="element-124" data-mp="1uc44xjgtave5">
            Un sistema completo de herramientas para preparar, interpretar y organizar tus lecturas.
          </p>
        </motion.div>

        <motion.div {...copyReveal} className="mx-auto mt-5 max-w-2xl border border-purple-100 bg-purple-50 px-5 py-5 text-center sm:mt-6 sm:px-8" data-id="element-125" data-mp="1yfa5cah8tscp">
          <motion.button onClick={scrollToPurchase} whileTap={{
          opacity: 0.92
        }} className="cta-desktop-hover solution-cta-attention relative flex w-full items-center justify-center gap-3 overflow-hidden rounded-xl bg-purple-900 px-5 py-4 text-sm font-black uppercase tracking-[0.1em] text-white shadow-[0_10px_24px_rgba(76,29,149,0.24)] transition-[background-color,box-shadow,opacity] duration-200 ease-out hover:bg-purple-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-900 sm:text-base" data-id="element-126" data-mp="1aoekxyf49zfh">
            <span className="cta-occasional-shine pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg]" aria-hidden="true" data-id="element-127" data-mp="233x7qylw8970" />
            <span className="relative flex items-center gap-3" data-id="element-128" data-mp="2c20v80gfvg1g">
              Quiero mi kit completo <ArrowRight size={20} aria-hidden="true" data-id="element-129" data-mp="2h1dgigrnwf1x" />
            </span>
          </motion.button>
          <p className="mt-3 text-xs font-semibold text-purple-900/65" data-id="element-130" data-mp="horhtxkrvadx">
            Descarga inmediata · 100% digital · Acceso de por vida
          </p>
        </motion.div>
      </div>
    </section>;
}